import { getEnv } from '@ctct/ctct-helpers';

class GoToHelper {
  paypalLinkMappings = {
    qa: 'https://www.sandbox.paypal.com/cgi-bin/webscr',
    stage: 'https://www.sandbox.paypal.com/cgi-bin/webscr',
    prod: 'https://www.paypal.com/cgi-bin/webscr',
  };

  public paypal(token: string) {
    const params = { cmd: '_express-checkout', token };
    const env = getEnv();

    let paypalUrl = this.paypalLinkMappings.prod;

    if (env === '.l1.') {
      paypalUrl = this.paypalLinkMappings.qa;
    } else if (env === '.s1.') {
      paypalUrl = this.paypalLinkMappings.stage;
    }

    const url = new URL(paypalUrl);

    Object.entries(params).forEach(([key, value]) => {
      url.searchParams.append(key, value);
    });

    // Navigate to PayPal
    window.location.href = url.toString();
  }
}

export const goToHelper = new GoToHelper();
